// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'mail';

export const Component = () => (
  <path d='M23.046 3.5H1.954c-.423 0-.75.139-1.032.417A1.352 1.352 0 0 0 .5 4.935v15.13c0 .417.14.74.422 1.018.281.278.61.417 1.032.417h21.092c.423 0 .75-.139 1.032-.417.281-.277.422-.601.422-1.018V4.935c0-.417-.14-.74-.422-1.018a1.387 1.387 0 0 0-1.032-.417Zm.516 4.349v12.215c0 .324-.188.51-.516.51H1.954c-.328 0-.516-.186-.516-.51V7.85l10.078 5.876c.281.185.61.278.984.278.375 0 .703-.093.984-.278L23.562 7.85Zm0-2.915V6.74l-10.593 6.2c-.188.046-.328.093-.469.093-.094 0-.281-.046-.515-.093L1.438 6.74V4.934c0-.324.188-.509.516-.509h21.092c.328 0 .516.185.516.51Z' />
);

export const viewBox = '0 0 25 25';
